<template>
    <div class="InfluencerProfile">


        <div class="max-w-2xl mx-auto mt-20">
            <div class="catch-1 inline-block well p-0 w-full">
                <div class="flex flex-wrap">
                    <div class="w-full md:w-2/5">
                        <img
                            :src="influencer.profile_photo_url"
                            class="spark-profile-photo-xxl mx-auto mb-4"
                            :alt="influencer.name"
                            style="margin-top: -40px; border: 0;"
                        />
                    </div>
                    <div class="w-full md:w-3/5 pl-5">
                        <p style="font-size: 18px;font-weight: 600;margin-top: 20px;">{{ influencer.name }}</p>
                        <div class="mt-5">
                            <div class="flex">
                                <div class="w-1/2 flex cursor-pointer">
                                    <span v-if="!influencer.favorite" id="fav-heart-off" @click="toggleFavorite" class="fa fa-heart-o mr-2" style="width: 15px; text-align: center; color: #1825d8; position: absolute; margin-top: 3px;" />
                                    <span v-else id="fav-heart-on" @click="toggleFavorite" class="fa fa-heart mr-2" style="width: 15px; text-align: center; color: red; position: absolute; margin-top: 3px;" />
                                    <p v-if="!influencer.favorite" id="fav-heart-text-off" @click="toggleFavorite" class="uppercase" style="font-size: 14px; margin-left: 20px;">Gem som favorit</p>
                                    <p v-else id="fav-heart-text-on" @click="toggleFavorite" class="uppercase" style="font-size: 14px; margin-left: 20px;">Fjern favorit</p>
                                </div>
                                <div class="w-1/2 pl-2 uppercase" style="font-size: 14px;">{{ influencer.gender ? influencer.gender.name : 'Ikke angivet' }}</div>
                            </div>
                            <div class="flex">
                                <div class="w-1/2 flex" v-if="influencer.country">
                                    <span class="fa fa-map-marker mr-2" style="width: 15px; text-align: center; color: #1825d8; position: absolute; margin-top: 3px;" />
                                    <!--<span class="fa fa-heart mr-2" style="color: red" />-->
                                    <p class="uppercase" style="font-size: 14px; margin-left: 20px;">
                                        {{ country.options.find(option => option.value === influencer.country).name || 'Ikke angivet' }}
                                    </p>
                                </div>
                                <div class="w-1/2 pl-2 uppercase magic-color-stars" style="font-size: 14px;">
                                    <RatingStars
                                        :value="influencer.reviews_score"
                                        class=""
                                        :disabled="true"
                                    />

                                    <!--
                                    {{ /* score */ influencer.reviews_score ? influencer.reviews_score : 0 }}
                                    {{ /* reviews */ influencer.reviews ? influencer.reviews.length : 0 }}
                                    {{ /* hired jobs */ influencer.hired_jobs_count ? influencer.hired_jobs_count : 0 }}
                                    -->

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="px-4 mb-5 mt-2">
                    <p>{{ influencer.bio }}</p>
                    <!--
                    <TextBlock :value="influencer.description"></TextBlock>
                    -->
                </div>
                <div v-if="influencer.channels" style="margin-bottom: 20px;padding: 10px 20px;flex-wrap: wrap;" class="flex w-full">
                    <div v-for="channel in influencer.channels" class="flex w-1/2">
                        <div>
                            <span style="color: #1825d8;font-size: 30px;margin-right: 10px;" :class="channel.platform ? channel.platform.icon : ''"></span>
                        </div>
                        <div style="font-size: 14px;line-height: 1.2;">
                            <p class="font-bold">{{ channel.reach }}</p>
                            <p>{{ channel.platform ? channel.platform.reach_name : '' }}</p>
                        </div>
                    </div>
                </div>
                <div v-if="influencer.trophies.length > 0" class="px-5 pb-8 pt-3">
                    <div class="flex gap-4 items-center mb-4">
                        <img src="/img/icons/icon_course_trophies.png" class="w-12"/>
                        <span class="font-bold text-lg text-uppercase text-black">TROFÆER</span>
                    </div>
                    <div class="grid grid-cols-2 md:grid-cols-4 gap-4 items-center">
                        <div v-for="trophy in influencer.trophies">
                            <img :src="trophy.image" :alt="trophy.name" class="h-12"/>
                        </div>
                    </div>
                </div>
                <div style="padding: 0px 20px;">
                    <div class="flex">
                        <div>
                            <img src="/img/interests-icon.png" alt="interests" style="width: 50px;" />
                        </div>
                        <p style="line-height: 45px;margin-left: 10px;font-weight: 600;">Verdensmål</p>
                    </div>
                    <div class="interests-wrapper">
                        <div v-for="interest in influencer.interests" class="interest-box" style="
                                            display: block;
                                            width: calc(25% - 10px);
                                            float: left;
                                            margin: 10px;
                                            margin-left: 0;
                                    ">
                            <img :src="'/img/interests/' + interest.id + '.png'" :alt="interest.name" />
                        </div>
                        <div style="clear: both;" />
                    </div>

                    <div class="flex justify-between mb-10 px-5 mt-10" v-if="inviteToCampaign">
                        <button class="btn btn-primary" style="background: red;font-size: 13px;font-weight: 600;padding: 7px 12px;border-radius: 0;text-transform: uppercase;color: white;">Inviter til kampagne</button>
                    </div>

                </div>
            </div>
        </div>

        <PageLoader :loading="loading" />

        <div style="margin-bottom: 50px;" class="mt-10">
            <div class="bg-white" style="width: 100vw; margin-left: calc(50% - 50vw);">
                <div class="container flex flex-wrap py-5">
                    <div class="w-full md:w-1/3 mb-4">
                        <h3 class="font-bold" style="font-style: normal;">
                            Anbefalinger
                        </h3>

                        <div class="uppercase magic-color-stars" style="font-size: 14px;">
                            <RatingStars
                                :value="influencer.reviews_score"
                                class=""
                                :disabled="true"
                            />
                        </div>
                        <p style="font-style: 10px;">({{ /* reviews */ influencer.reviews ? influencer.reviews.length : 0 }} anbefalinger)</p>
                    </div>

                    <div class="w-full md:w-2/3 flex-grow" style="    align-self: center;">
                        <InfluencerProfileReviewsTab v-if="!loading" :reviews="influencer.reviews" />
                    </div>
                </div>
                <div class="catch-14" style="margin-top: -20px;"></div>
            </div>

            <div style="    margin-top: 120px;">
                <h3 style="
                    width: 100%;
                    text-align: center;
                    font-size: 22px;
                    font-style: normal;
                    font-weight: 600;
                    color: white;
                    text-transform: uppercase;
                ">
                    Medier
                </h3>
                <div>
                    <InfluencerProfileChannelsTab
                        v-if="!loading"
                        :channels="influencer.channels"
                        :preselect="preselectChannel"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<style type="text/less" lang="less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';
@import '~dashboard-less/spark/components/Tabs';

.InfluencerProfile {
    .Tabs(@brand-primary);
}

.InfluencerProfile .Tabs > li:not(.active) > a {
    @apply text-gray-700;
}

.InfluencerProfile {
    .CoverImage {
        min-height: 150px;
    }

    .InfluencerProfile__cover {
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.2));

        .RatingStars .star {
            font-size: 30px;
        }
    }
}
</style>
<script type="text/babel">
import CoverImage from 'dashboard-js/components/utilities/CoverImage'
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'
import InfluencerProfileChannelsTab from './InfluencerProfileChannelsTab'
import InfluencerProfileReviewsTab from 'dashboard-js/components/influencers/InfluencerProfileReviewsTab'
import PageLoader from 'dashboard-js/components/utilities/PageLoader'
import RatingStars from 'dashboard-js/components/reviews/RatingStars'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'
import Tab from 'dashboard-js/components/tabs/Tab'
import TabContent from 'dashboard-js/components/tabs/TabContent'
import TabPanel from 'dashboard-js/components/tabs/TabPanel'
import Tabs from 'dashboard-js/components/tabs/Tabs'
import TextBlock from 'dashboard-js/components/utilities/TextBlock'

export default {
    components: {
        TabPanel,
        Tab,
        TabContent,
        Tabs,
        RatingStars,
        CoverImage,
        TextBlock,
        PageLoader,
        InfluencerProfileReviewsTab,
        InfluencerProfileChannelsTab,
    },

    mixins: [HasLoadingState, RestoreOnPageBack],

    props: ['dataInfluencer', 'apiUrl', 'platform', 'inviteToCampaign'],

    data() {
        return {
            influencer: {
                channels: null,

                ...this.dataInfluencer,
            },

            country: {
                options: [
                    { name: 'Danmark', value: 'DK' },
                    { name: 'Sverige', value: 'SE' },
                    { name: 'Norge', value: 'NO' },
                ],
            },
        }
    },

    computed: {
        endpoint() {
            return this.apiUrl ? this.apiUrl : route('api.influencer.show', this.dataInfluencer)
        },

        preselectChannel() {
            if (this.platform && this.influencer.channels) {
                return this.influencer.channels.find(
                    channel => channel.platform_id === this.platform.id
                )
            }
            return null
        },
    },

    created() {
        this.onPageVisit(() => {
            axios
                .get(this.endpoint)
                .then(response => Object.assign(this.influencer, response.data.data))
                .then(this.finishLoading())
                .then(this.saveState)
        })
    },

  methods: {
    toggleFavorite() {
        let endpoint = this.endpoint.split('?')[0] + '/favorite?' + (this.endpoint.split('?')[1] || '')
          axios
              .get(endpoint)
              .then(response => Object.assign(this.influencer, {
                ...this.influencer,
                favorite: response.data.favorite,
              }))
              .then(this.finishLoading())
              .then(this.saveState)
        },
    },

    beforeDestroy() {
        this.saveState()
    },
}
</script>
